window.getCsrfToken = function () {
  const tokenElement = $('meta[name="csrf-token"]');
  return tokenElement.length > 0 ? tokenElement.attr('content') : '';
}
